"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Z20SceneNames {
}
Z20SceneNames.Menu = "Z20MenuScene";
Z20SceneNames.Preload = "Z20PreloadScene";
Z20SceneNames.RuleDisplay = "Z20RuleDisplayScene";
Z20SceneNames.Game = "Z20GameScene";
Z20SceneNames.Cutscene = "Z20CutScene";
Z20SceneNames.SeedPicker = "Z20SeedPickerScene";
exports.default = Z20SceneNames;
